// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/loading_spinner'. 'node_modules/@grnhse/seedling/lib/azalea/components/loading_spinner.js' implicitly has an 'any' type.
import LoadingSpinner from '@grnhse/seedling/lib/azalea/components/loading_spinner';
import React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/components/Select'. 'app/webpack/javascripts/shared/components/Select.js' implicitly has an 'any' type.
import Select from 'shared/components/Select';
import styled from 'styled-components';
import { padding } from '@grnhse/seedling/lib/azalea/constants';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card'. 'node_modules/@grnhse/seedling/lib/azalea/components/card.js' implicitly has an 'any' type.
import { CardBody } from '@grnhse/seedling/lib/azalea/components/card';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';

export const GdprCardBody = styled(CardBody)`
  padding-left: 25px;
`;

export const ContentBody = styled.div`
  line-height: 22px;
  font-size: 14px;
  ${fontWeight('normal')};
`;

export const ContentHeader = styled(ContentBody)`
  ${fontWeight('heavy')};
`;

export const ContentDescription = styled(ContentBody)`
  color: ${colors.mediumGrey};
`;

export const ContentBodyEmpty = styled(ContentBody)`
  color: ${colors.mediumGrey};
  font-style: italic;
`;

export const IconComponent = styled.div`
  position: relative;
  top: 2px;
  float: left;
`;

export const LeftComponentWrapper = styled.div`
  margin-left: 25px;
  float: left;
  width: 85%;
  line-height: 24px;
`;

export const RightComponentWrapper = styled.div`
  float: right;
`;

export const Table = styled.table`
  font-size: 14px;
  font-weight: ${fontWeight.light};
  line-height: 22px;
  color: ${colors.darkestGrey};
  td:not(:last-child) {
    padding: 0 20px 0 0;
  }
`;

export const ContentContainer = styled.div`
  margin-bottom: 24px;
`;

export const SmallContentContainer = styled.div`
  margin-bottom: 8px;
`;

export const ErrorsContainer = styled.div`
  color: ${colors.darkRed};
  font-size: 14px;
  font-weight: ${fontWeight.normal};
`;

export const StyledSelect = styled(Select)`
  display: inline-block;
  width: 50%;
  padding-bottom: 5px;
`;

export function Loading() {
  return (
    <LoadingSpinner
      size="medium"
      style={{ display: 'block', margin: '1em auto' }}
    />
  );
}

export function Required() {
  const style = { color: colors.darkRed } as const;
  return <span style={style}>*</span>;
}

export const DataProtectionOfficerCard = styled(CardBody)`
  padding-left: 24px !important;
  padding-right: 24px !important;
  margin-bottom: 20px;
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex !important;
  align-items: center !important;
  width: 100%;
  border-top: 1px solid ${colors.lightGrey};
`;

export const HeaderDescription = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  color: ${colors.mediumGrey};
  ${fontWeight('normal')};
`;

export const Link = styled.a`
  margin-left: 5px;
`;

export const ConsentEmailCard = styled(CardBody)`
  margin-bottom: ${padding.normal};
`;

export const ContentWrapper = styled.div`
  ${/* @ts-expect-error */ ''}
  ${(props) => props.redesign && `margin-bottom: 24px;`};
`;
